var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourseAdminTabDemo = function SvgCourseAdminTabDemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "url(#course-admin-tab-demo_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.21 30.58 20.63 40c10.967-.064 19.806-8.903 19.87-19.87l-9.42-9.42z",
    clipRule: "evenodd",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFCF2",
    fillRule: "evenodd",
    d: "M30.177 10.322H12.113c-.71 0-1.29.58-1.29 1.29v18.065c0 .71.58 1.29 1.29 1.29H24.37l7.097-7.096V11.613c0-.71-.581-1.29-1.29-1.29",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "M24.371 23.871v7.097l7.097-7.097zm-9.677 2.581h7.096v-1.29h-7.096zm12.258-5.161H14.694v1.29h12.258zm0-3.871H14.694v1.29h12.258zm-2.581-3.871h-9.677v1.29h9.677z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "course-admin-tab-demo_svg__a",
    x1: 0.5,
    x2: 42.736,
    y1: 40,
    y2: 2.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F3AB"
  })))));
};
export { SvgCourseAdminTabDemo as ReactComponent };
export default __webpack_public_path__ + "fonts/course-admin-tab-demo-1d4c8ff1bfa6c90370695b9546996da4.svg";